import $ from 'jquery'
import template from 'lodash.template'
import AjaxList from '../../components/ajaxList'
import { format } from '../../utils/currency'
import '../../plugins/dropdown'

class Module {
  constructor ($module) {
    this.$container = $module.find('.js-partner-account-list')
    this.$list = $module.find('.b-networks__list_wrap')
    this.$templateEl = $module.find('.js-partner-account-template')
    this.template = template(this.$templateEl.html())

    this.list = new AjaxList({
      $container: this.$container,
      $form: $module.find('.js-partner-filter-form'),
      $sorting: $module.find('.js-sorting .js-dropdown-custom'),
      prefix: 'partner_show',
      append: (response, replace) => {
        this.replace(response)
      }
    })
  }

  replace (response) {
    const $content = $('<div>')

    this.$list.empty()

    if (Object.prototype.hasOwnProperty.call(response, 'accounts') && !response.accounts.length) {
      this.$container.addClass('empty_list')
    } else {
      this.$container.removeClass('empty_list')

      response.accounts.forEach((v) => {
        $content.append(this.render(v, response.pagination.sort_field))
      })

      this.$list.append($content)
    }
  }

  render (value, sortField) {
    const partner = this.$templateEl.data('partner')
    const statusClass = (function (status) {
      if (['new', 'pending'].indexOf(status) > -1) {
        return 'text-warning'
      } else if (['declined', 'block', 'deleted', 'error'].indexOf(status) > -1) {
        return 'text-danger'
      } else {
        return 'text-success'
      }
    }(value.verified))
    const accountUrl = this.$templateEl.data('account-url').replace(/_id_/, value.id)
    const depositUrl = this.$templateEl.data('deposit-url').replace(/_id_/, value.id)
    const historyUrl = this.$templateEl.data('history-url').replace(/_id_/, value.id)
    const archiveUrl = this.$templateEl.data('archive-url').replace(/_id_/, value.id)
    const shareUrl = this.$templateEl.data('share-url').replace(/_id_/, typeof value.clientId !== 'undefined' ? value.id : null)
    const paymentAvailable = value.canPay
    const historyAvailable = ['verified', 'block', 'deleted'].indexOf(value.verified) > -1
    const archiveAvailable = value.canArchive
    const sortClass = sortField === 'balance' ? 'b-networks__section_sorted_by_sum' : ''

    return this.template({
      partner: partner,
      enabled: value.enabled,
      login: value.login,
      balance: format(value.balance, this.$templateEl.data('currency')),
      tokenRemoved: value.token_removed,
      verifiedName: value.verified_name,
      statusClass: statusClass,
      accountUrl: accountUrl,
      depositUrl: depositUrl,
      historyUrl: historyUrl,
      archiveUrl: archiveUrl,
      shareUrl: shareUrl,
      paymentAvailable: paymentAvailable,
      historyAvailable: historyAvailable,
      archiveAvailable: archiveAvailable,
      shareAvailable: typeof value.clientId !== 'undefined' ? value.clientId : null,
      sortClass: sortClass
    })
  }
}

$(function () {
  $('.js-partner-show').each(function () {
    new Module($(this))
  })
})
